import { Tracker } from "react-tracker";

const configureTracker = () => new Tracker();

export default configureTracker();
